import { SHOW_NOTIFICATION } from 'src/store/types'

/**
 *
 * Accepts below  attributes
 * {
        vuexAction: 'doGeneralReceiptCancellationAction' // Used to call vuex action directly,
        data: {test: 1, ...} // payload alternate for dataCallback
        dataCallback: performReceiptCancellation // Used to get payload from callback function (optional),
        label: receiptData.receipt_number, // Label used in confirmation dialog
        operationTitle: 'Custom Title' // Only if required if not states default title will be taken
      }
 * */

export default {
  methods: {
    async customAction(actions) {
      let { vuexAction, id = null, label, data = {}, dataCallback, operationTitle = false } = actions
      if (typeof dataCallback === 'function') {
        data = await dataCallback()
      }
      if (!operationTitle) {
        operationTitle = this.$t('common.words.delete')
      }
      await new Promise((resolve, reject) => {
        this.$q
          .dialog({
            title: this.$t('common.words.warning'),
            message: this.$t(`common.message.alert.youAreAboutTo`, { operation: operationTitle, label: label }),
            noEscDismiss: true,
            noBackdropDismiss: true,
            html: true,
            position: 'top',
            ok: {
              label: this.$t('common.button.yes'),
              rounded: true,
              unelevated: true,
              color: 'action-button-success',
            },
            cancel: {
              label: this.$t('common.button.no'),
              rounded: true,
              unelevated: true,
              outline: true,
              color: 'action-button-dark',
            },
          })
          .onOk(() => {
            this.$store.dispatch(vuexAction, data ? data : id)
            resolve()
          })
          .onCancel(() => {
            this.$store.commit(SHOW_NOTIFICATION, {
              title: this.$t(`common.message.info.operationAborted`, { operation: operationTitle }),
              type: 'warning',
              actions: [
                {
                  label: this.$t('common.button.dismiss'),
                  handler: () => {},
                },
              ],
            })
            reject()
          })
      })
    },
  },
}
